import React from 'react';
import './Seperator.css'

const Seperator = () => {
  return (
    <div className='seperator'></div>
  )
}

export default Seperator